"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var framer_motion_1 = require("framer-motion");
var LoadingGlobalContainer = function (_a) {
    var description = _a.description;
    return ((0, jsx_runtime_1.jsx)(framer_motion_1.motion.div, __assign({ style: {
            position: 'fixed',
            zIndex: 1800,
            inset: 0,
            display: 'grid',
            placeItems: 'center',
            backgroundColor: 'rgba(255, 255, 255, 0.5)',
            backdropFilter: 'blur(20px)',
        }, initial: { x: -50, opacity: 0 }, animate: { x: 0, opacity: 1 }, transition: { duration: 0.5 } }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ style: { display: 'grid', placeItems: 'center', gap: '20px' } }, { children: [(0, jsx_runtime_1.jsx)(material_1.CircularProgress, { color: "secondary" }), description && ((0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h5", sx: { padding: { xs: '20px' }, textAlign: 'center' } }, { children: description })))] })) })));
};
exports.default = LoadingGlobalContainer;
